export default __webpack_public_path__ + "media/assets/fonts/roboto-slab-v13-latin-regular-d1f41821ac96a900c922e14a604de549.ttf";